var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading"},[_c('h6',{staticClass:"heading__title"},[_vm._v("\n\t\t"+_vm._s(_vm.title)+"\n\t")])])}
var staticRenderFns = []

export { render, staticRenderFns }